// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 发送验证码 POST /api/login/captcha */
export async function getFakeCaptcha(
  params: {
    // query
    /** 手机号 */
    phone?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.FakeCaptcha>('/api/login/captcha', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/v1/auth/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/v1/auth/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/v1/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

// 刷新token
export async function refreshToken(options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/v1/auth/token/refresh', {
    method: 'POST',
    ...(options || {}),
  });
}
/** 图片验证码 GET /api/v1/auth/captcha */
export async function captchaImgApi() {
  return request<API.CaptchaData>('/api/v1/auth/captcha', {
    method: 'GET',
  });
}

/** 重置密码 POST /api/v1/func/users/password/reset */
export async function passwordReset(body: API.PwdReset, options?: { [key: string]: any }) {
  return request<API.CaptchaData>('/api/v1/func/users/password/reset', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 首次重置密码 POST /api/v1/func/users/password/init_reset */
export async function InitpasswordReset(body: API.PwdReset, options?: { [key: string]: any }) {
  return request<API.CaptchaData>('/api/v1/func/users/password/init_reset', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}
